(ns frontend.ui.page.lp-portal.landing-page.sub
  (:require
   [re-frame.core :as rf]
   [frontend.lp-portal.sub :as portal-sub]))

(def landing-page-data-path [::landing-page-data])
(def landing-page-commitments-path (conj landing-page-data-path :landing-page-lp-commitments))
(def landing-page-feeder-commitments-path
  (conj landing-page-data-path :landing-page-feeder-commitments))
(def landing-page-funds-path (conj landing-page-data-path :fund-landing-page-data))

(def funds-sort-path [::funds-sort-path])
(def feeder-commitments-sort-path [::feeders-sort-path])
(def commitments-sort-path [::commitments-sort-path])

(rf/reg-sub
 ::tenant
 (fn [db]
   (:tenant db)))

(rf/reg-sub
 ::account
 (fn [db]
   (:account db)))

(rf/reg-sub
 ::lp-reports
 (fn [db]
   (:lp-reports db)))

(rf/reg-sub
 ::selected-news-year
 (fn [db]
   (:selected-news-year db)))

(rf/reg-sub
 ::selected-news-type
 (fn [db]
   (:selected-news-type db)))

(rf/reg-sub
 ::selected-news-category
 (fn [db]
   (:selected-news-category db)))

(rf/reg-sub
 ::news-items
 (fn [db]
   (:news-items db)))

(rf/reg-sub
 ::news-items-loading
 (fn [db]
   (:news-items-loading db)))

(rf/reg-sub
 ::landing-page-loading
 (fn [db]
   (:landing-page-loading db)))

(rf/reg-sub
 ::news-types
 (fn [db]
   (:news-types db)))

(rf/reg-sub
 ::news-categories
 (fn [db]
   (:news-categories db)))

(rf/reg-sub
 ::latest-reports-active-tab-key
 (fn [db]
   (:lp-latest-reports-active-tab-key db)))

(rf/reg-sub
 ::landing-page-data
 (fn [db]
   (get-in db landing-page-data-path)))

(rf/reg-sub
 ::landing-page-commitments
 (fn [db]
   (get-in db landing-page-commitments-path)))

(rf/reg-sub
 ::landing-page-feeder-commitments
 (fn [db]
   (get-in db landing-page-feeder-commitments-path)))


(rf/reg-sub
 ::landing-page-funds
 (fn [db]
   (get-in db landing-page-funds-path)))

(rf/reg-sub
 ::funds-sort-order
 (fn [db]
   (or (get-in db funds-sort-path)
       {:keys      [:lp-report/data :fund-landing-page-data :fund-name]
        :direction "DESC"})))

(rf/reg-sub
 ::feeder-commitments-sort-order
 (fn [db]
   (or (get-in db feeder-commitments-sort-path)
       {:keys      [:fund-name]
        :direction "DESC"})))

(rf/reg-sub
 ::commitments-sort-order
 (fn [db]
   (or (get-in db commitments-sort-path)
       {:keys      [:fund-name]
        :direction "DESC"})))
